module.exports = __webpack_public_path__ + "static/media/favicon05.c3913444.webp";